(function () {
  var ROOT = document.documentElement;
  var vR = 100, vG = 180, vB = 140;

  /* ── Farb-Extraktion aus Produktbild ────────── */
  function extractAndApply(src) {
    if (!src) return;
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = 28; c.height = 28;
        var cx = c.getContext('2d');
        cx.drawImage(img, 0, 0, 28, 28);
        var d = cx.getImageData(0, 0, 28, 28).data;
        var r = 0, g = 0, b = 0, n = 0;
        for (var i = 0; i < d.length; i += 4) {
          var br = (d[i] + d[i+1] + d[i+2]) / 3;
          if (br > 228 || br < 16) continue;
          r += d[i]; g += d[i+1]; b += d[i+2]; n++;
        }
        if (n < 25) return;
        /* 55% extracted + 45% neutral pastel → immer angenehm */
        vR = Math.round(r/n * .55 + 130 * .45);
        vG = Math.round(g/n * .55 + 170 * .45);
        vB = Math.round(b/n * .55 + 155 * .45);
        ROOT.style.setProperty('--vibe-rgb', vR + ',' + vG + ',' + vB);
      } catch (e) {}
    };
    img.src = src;
  }

  /* ── Ambient-Partikel-Canvas ─────────────────── */
  var canvas, ctx, pts = [];

  function rnd(a, b) { return a + Math.random() * (b - a); }

  function freshPt() {
    return {
      x: rnd(0, canvas.width),
      y: rnd(canvas.height * .2, canvas.height + 20),
      r: rnd(1.5, 5.8),
      vx: rnd(-0.14, 0.14),
      vy: rnd(-0.26, -0.07),
      alpha: rnd(0.12, 0.44),
      life: rnd(0.5, 1.0),
      decay: rnd(0.0005, 0.0013),
    };
  }

  function initCanvas() {
    canvas = document.createElement('canvas');
    canvas.id = 'vibe-canvas';
    document.body.insertBefore(canvas, document.body.firstChild);
    ctx = canvas.getContext('2d');
    function resize() { canvas.width = window.innerWidth; canvas.height = window.innerHeight; }
    resize();
    window.addEventListener('resize', resize);
    for (var i = 0; i < 65; i++) pts.push(freshPt());
    tick();
  }

  function tick() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (var i = pts.length - 1; i >= 0; i--) {
      var p = pts[i];
      p.x += p.vx; p.y += p.vy; p.life -= p.decay;
      if (p.life <= 0 || p.y < -30) { pts.splice(i, 1); pts.push(freshPt()); continue; }
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(' + vR + ',' + vG + ',' + vB + ',' + (p.alpha * p.life) + ')';
      ctx.fill();
    }
    requestAnimationFrame(tick);
  }

  /* ── Description: sanft aufklappbar ─────────── */
  function setupDesc() {
    var desc = document.querySelector('.product__description');
    if (!desc) return;
    if (desc.scrollHeight < 90) return;
    var full = desc.scrollHeight;
    desc.style.transition = 'max-height 0.42s cubic-bezier(0.4,0,0.2,1)';
    desc.style.overflow = 'hidden';
    desc.style.maxHeight = '4em';
    desc.classList.add('vibe-desc--clipped');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vibe-readmore';
    btn.textContent = 'Mehr lesen';
    desc.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function () {
      var open = desc.classList.toggle('vibe-desc--open');
      desc.style.maxHeight = open ? full + 'px' : '4em';
      btn.textContent = open ? 'Weniger' : 'Mehr lesen';
    });
  }

  /* ── Boot ────────────────────────────────────── */
  function init() {
    initCanvas();
    setupDesc();
    var imgEl = document.querySelector(
      '.product__media-item--image img, .product-media-container img, .product__media img'
    );
    if (imgEl) {
      extractAndApply(imgEl.currentSrc || imgEl.src || imgEl.getAttribute('src'));
    }
    document.addEventListener('variant:changed', function () {
      var el = document.querySelector('.product__media-item--image img, .product__media img');
      if (el) extractAndApply(el.currentSrc || el.src);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
